import { galleryReducer } from "./gallery";
import { combineReducers } from "redux";

export default combineReducers({
    gallery: galleryReducer
});